export default function Step1() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
            <path
                d="M23.25 8.06836H25.5C27.1569 8.06836 28.5 9.4115 28.5 11.0684V29.0684C28.5 30.7252 27.1569 32.0684 25.5 32.0684H10.5C8.84315 32.0684 7.5 30.7252 7.5 29.0684V11.0684C7.5 9.4115 8.84315 8.06836 10.5 8.06836H12.75"
                stroke="#3F68E0"
                strokeWidth="1.26"
            />
            <path d="M13.5 21.0947L16.9737 24.5684L22.9737 18.5684" stroke="#3F68E0" strokeWidth="1.26" />
            <path
                d="M12.63 6.56836C12.63 6.08787 13.0195 5.69836 13.5 5.69836H22.5C22.9805 5.69836 23.37 6.08787 23.37 6.56836V9.56836C23.37 10.0488 22.9805 10.4384 22.5 10.4384H13.5C13.0195 10.4384 12.63 10.0488 12.63 9.56836V6.56836Z"
                stroke="#3F68E0"
                strokeWidth="1.26"
            />
        </svg>
    );
}
